import { jsxs as o, jsx as t } from "react/jsx-runtime";
import e from "../../../svg-icon/svg-icon.component.js";
function h(i) {
  return /* @__PURE__ */ o(
    e,
    {
      width: "32",
      height: "32",
      viewBox: "0 0 32 32",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...i,
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            d: "M8.64437 18.6662C7.99708 16.8702 7.66549 13.9892 9.1616 11.2462C10.5237 8.74833 12.9798 7.18868 16.0018 7.18868C19.3763 7.18868 21.6666 9.09084 22.842 11.2462C24.2706 13.8661 24.0423 16.7709 23.3593 18.6662H31.7065C31.9259 17.5364 32.7986 12.5179 29.8848 7.65231C27.1328 3.05675 22.1402 0 16.0008 0C9.519 0 4.67724 3.37246 2.11687 7.65231C-0.783026 12.499 0.0618283 17.4639 0.29513 18.6662H8.64337H8.64437Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            d: "M2.39477 23.8832C4.86976 27.7659 9.46234 31.0719 16.0008 31.0719C21.7866 31.0719 26.7495 28.3636 29.6067 23.8832H2.39378H2.39477Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
export {
  h as DefaultSymbolNegativeLogo
};
//# sourceMappingURL=negative.js.map
